import { generateArrayWithValues } from '@freelancer/datastore/testing/helpers';
import { SupportTypeApi } from 'api-typings/support/support';
import { AiPromptContextTypeApi } from 'api-typings/users/users';
import type {
  AiPromptBlob,
  AiPromptBuilder,
  AiPromptVars,
} from './ai-prompt-builders.model';

interface GenerateBlobsOptions {
  readonly names?: readonly string[];
  readonly blobs?: readonly string[];
  readonly vars?: readonly AiPromptVars[];
}

interface GenerateBlobOptions {
  readonly name?: string;
  readonly blob?: string;
  readonly vars?: AiPromptVars;
}

export function generateAiPromptBuilderObject({
  // id, name, and context reference shares the same value in implementation atm
  id = SupportTypeApi.VERIFIED_SALES,
  name = SupportTypeApi.VERIFIED_SALES,
  contextReference = SupportTypeApi.VERIFIED_SALES,
  contextType = AiPromptContextTypeApi.SUPPORT,
  blobs = generateBlobs({}),
  vars = undefined,
}): AiPromptBuilder {
  return {
    id,
    name,
    contextReference,
    contextType,
    blobs,
    vars,
  };
}

export function generateBlobs({
  names = generateArrayWithValues(10, 'blob'),
  blobs = generateArrayWithValues(10, 'blob'),
  vars = undefined,
}: GenerateBlobsOptions): readonly AiPromptBlob[] {
  return names.map((name, index) => {
    return generateBlob({
      name,
      blob: blobs[index],
      vars: vars ? vars[index] : undefined,
    });
  });
}

function generateBlob({
  name = 'blob',
  blob = 'blob',
  vars = undefined,
}: GenerateBlobOptions): AiPromptBlob {
  return {
    name,
    blob,
    vars,
  };
}
